export const translate = (message: string, lang: string | null): string => {
  const dict = {
    "Amount of sales": {
      ru: "Сумма продаж",
      uz: "Summa miqdori",
    },
    "Count of checks": {
      ru: "Количество продаж",
      uz: "Sotish soni",
    },
    "Average check": {
      ru: "Средний чек",
      uz: "O'rtacha chek miqdori",
    },
    "Amount of refunds": {
      ru: "Сумма возвратов",
      uz: "Qaytarilgan to'lovlar",
    },
    "Count of refunds": {
      ru: "Количество возвратов",
      uz: "Qaytishlar soni",
    },

    CARD: {
      ru: "Карта",
      uz: "Karta",
    },
    CASH: {
      ru: "Наличные",
      uz: "Naqd pul",
    },
    CASHLESS: {
      ru: "Перевод",
      uz: "O'tkazma",
    },
    UZ_CARD: {
      ru: "UZ карта",
      uz: "UZ karta",
    },

    ADVANCE: {
      ru: "Аванс",
      uz: "Avans",
    },
    CREDIT: {
      ru: "Кредит",
      uz: "Kredit",
    },
    SALE: {
      ru: "Продажа",
      uz: "Sotish",
    },

    MONDAY: {
      ru: "Пн",
      en: "Mn",
      uz: "Dsh",
    },
    TUESDAY: {
      ru: "Вт",
      en: "Tu",
      uz: "Ssh",
    },
    WEDNESDAY: {
      ru: "Ср",
      en: "We",
      uz: "Chb",
    },
    THURSDAY: {
      ru: "Чт",
      en: "Th",
      uz: "Pb",
    },
    FRIDAY: {
      ru: "Пт",
      en: "Fr",
      uz: "Jm",
    },
    SATURDAY: {
      ru: "Сб",
      en: "Sa",
      uz: "Shb",
    },
    SUNDAY: {
      ru: "Вс",
      en: "Su",
      uz: "Yak",
    },
  };

  let result = message;

  if (message in dict) {
    // @ts-ignore
    if (lang in dict[message]) {
      // @ts-ignore
      result = dict[message][lang];
    }
  }

  return result;
};
